import { createAction, props } from '@ngrx/store';
import { AchEnrollment } from '@src/app/features/ach-enrollment/models/ach-enrollment.model';

export const createAchEnrollment = createAction(
    '[AchEnrollment] CREATE_ACH_ENROLLMENT',
    props<{ achEnrollment: AchEnrollment }>()
);

export const createAchEnrollmentSuccess = createAction(
    '[AchEnrollment] CREATE_ACH_ENROLLMENT_SUCCESS'
);

export const createAchEnrollmentFailure = createAction(
    '[AchEnrollment] CREATE_ACH_ENROLLMENT_FAILURE'
);

export const successPageExited = createAction('[AchEnrollment] SUCCESS_PAGE_EXITED');
